var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1421px",
    height: "1145px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 473.167,-0.5 946.833,-0.5 1420.5,-0.5C 1420.5,381.167 1420.5,762.833 1420.5,1144.5C 946.833,1144.5 473.167,1144.5 -0.5,1144.5C -0.5,762.833 -0.5,381.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25d0db",
    d: "M 706.5,111.5 C 803.029,150.428 899.362,189.928 995.5,230C 899.564,197.464 803.73,164.298 708,130.5C 617.255,162.305 526.422,194.139 435.5,226C 431.578,227.647 427.578,228.647 423.5,229C 518.055,190.1 612.388,150.934 706.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#14ceda",
    d: "M 518.5,279.5 C 625.992,312.458 733.659,344.958 841.5,377C 860.481,385.678 867.314,400.178 862,420.5C 859.021,427.818 854.187,433.651 847.5,438C 828.662,448.92 809.662,459.587 790.5,470C 826.68,506.014 862.68,542.18 898.5,578.5C 871.68,605.82 844.68,632.986 817.5,660C 816.833,660.667 816.167,660.667 815.5,660C 779.986,624.32 744.32,588.82 708.5,553.5C 697.843,570.805 687.676,588.472 678,606.5C 665.499,626.805 648.666,631.305 627.5,620C 621.493,615.487 617.326,609.654 615,602.5C 582.704,495.007 550.537,387.341 518.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 572.5,334.5 C 656.466,358.767 740.133,383.934 823.5,410C 792.805,427.01 762.471,444.51 732.5,462.5C 770.486,500.986 808.653,539.32 847,577.5C 847.667,578.167 847.667,578.833 847,579.5C 837.167,589.333 827.333,599.167 817.5,609C 816.833,609.667 816.167,609.667 815.5,609C 777.32,570.653 738.986,532.486 700.5,494.5C 682.762,524.969 665.262,555.635 648,586.5C 622.772,502.537 597.606,418.537 572.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1acfda",
    d: "M 880.5,767.5 C 868.678,766.505 856.678,766.172 844.5,766.5C 844.5,762.5 844.5,758.5 844.5,754.5C 861.5,754.5 878.5,754.5 895.5,754.5C 895.5,773.5 895.5,792.5 895.5,811.5C 891.5,811.5 887.5,811.5 883.5,811.5C 883.833,804.738 883.5,798.738 882.5,793.5C 872.863,807.179 859.53,813.846 842.5,813.5C 810.775,811.608 792.609,794.942 788,763.5C 784.854,740.31 792.354,721.476 810.5,707C 831.166,695.203 852.166,694.537 873.5,705C 881.024,709.69 887.024,715.857 891.5,723.5C 887.283,726.53 882.783,729.196 878,731.5C 867.866,716.525 853.699,710.358 835.5,713C 819.556,716.277 809.389,725.777 805,741.5C 801.853,755.464 803.52,768.798 810,781.5C 820.604,795.818 834.77,801.318 852.5,798C 868.917,794.414 878.25,784.247 880.5,767.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#19ceda",
    d: "M 404.5,698.5 C 409.833,698.5 415.167,698.5 420.5,698.5C 420.5,736.5 420.5,774.5 420.5,812.5C 415.167,812.5 409.833,812.5 404.5,812.5C 404.5,774.5 404.5,736.5 404.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20cfdb",
    d: "M 543.5,811.5 C 540.061,811.747 536.728,811.414 533.5,810.5C 522.831,780.663 511.665,750.996 500,721.5C 497.113,751.806 494.613,782.139 492.5,812.5C 487.167,812.5 481.833,812.5 476.5,812.5C 478.968,774.578 481.968,736.745 485.5,699C 492.747,698.188 499.914,698.354 507,699.5C 517.663,727.489 528.33,755.489 539,783.5C 549.931,755.539 560.765,727.539 571.5,699.5C 578.803,698.503 586.137,698.169 593.5,698.5C 596.218,736.498 598.884,774.498 601.5,812.5C 596.238,812.805 591.072,812.471 586,811.5C 584.114,781.986 581.448,752.653 578,723.5C 566.776,753.018 555.276,782.351 543.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1dcfda",
    d: "M 746.5,810.5 C 741.36,811.488 736.026,811.821 730.5,811.5C 727.704,803.114 724.704,794.781 721.5,786.5C 704.513,785.501 687.513,785.167 670.5,785.5C 667.972,794.233 665.139,802.9 662,811.5C 656.593,812.473 651.093,812.807 645.5,812.5C 658.565,774.639 672.232,736.973 686.5,699.5C 692.807,698.336 699.141,698.169 705.5,699C 719.854,735.918 733.521,773.084 746.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18ceda",
    d: "M 1012.5,811.5 C 992.167,811.5 971.833,811.5 951.5,811.5C 951.5,774.167 951.5,736.833 951.5,699.5C 971.66,698.503 991.993,698.17 1012.5,698.5C 1012.5,703.5 1012.5,708.5 1012.5,713.5C 997.5,713.5 982.5,713.5 967.5,713.5C 967.5,725.167 967.5,736.833 967.5,748.5C 980.833,748.5 994.167,748.5 1007.5,748.5C 1007.5,753.167 1007.5,757.833 1007.5,762.5C 994.167,762.5 980.833,762.5 967.5,762.5C 967.5,774.167 967.5,785.833 967.5,797.5C 982.5,797.5 997.5,797.5 1012.5,797.5C 1012.5,802.167 1012.5,806.833 1012.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfefe",
    d: "M 695.5,716.5 C 696.79,717.058 697.623,718.058 698,719.5C 703.774,736.825 709.941,753.991 716.5,771C 703.171,771.5 689.837,771.667 676.5,771.5C 682.985,753.228 689.319,734.895 695.5,716.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ae0e7",
    d: "M 896.5,811.5 C 896.167,811.5 895.833,811.5 895.5,811.5C 895.5,792.5 895.5,773.5 895.5,754.5C 878.5,754.5 861.5,754.5 844.5,754.5C 844.5,758.5 844.5,762.5 844.5,766.5C 856.678,766.172 868.678,766.505 880.5,767.5C 868.167,767.5 855.833,767.5 843.5,767.5C 843.5,762.833 843.5,758.167 843.5,753.5C 861.167,753.5 878.833,753.5 896.5,753.5C 896.5,772.833 896.5,792.167 896.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbf1f4",
    d: "M 895.5,811.5 C 895.833,811.5 896.167,811.5 896.5,811.5C 892.03,812.486 887.363,812.819 882.5,812.5C 882.5,806.167 882.5,799.833 882.5,793.5C 883.5,798.738 883.833,804.738 883.5,811.5C 887.5,811.5 891.5,811.5 895.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abeef1",
    d: "M 533.5,810.5 C 536.728,811.414 540.061,811.747 543.5,811.5C 542.036,812.16 540.369,812.493 538.5,812.5C 536.36,812.444 534.694,811.777 533.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5edf1",
    d: "M 746.5,810.5 C 747.043,810.56 747.376,810.893 747.5,811.5C 741.68,812.816 736.013,812.816 730.5,811.5C 736.026,811.821 741.36,811.488 746.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0eff2",
    d: "M 951.5,699.5 C 951.5,736.833 951.5,774.167 951.5,811.5C 971.833,811.5 992.167,811.5 1012.5,811.5C 992.007,812.497 971.34,812.831 950.5,812.5C 950.168,774.663 950.502,736.996 951.5,699.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0dced9",
    d: "M 404.5,832.5 C 407.5,832.5 410.5,832.5 413.5,832.5C 413.5,854.167 413.5,875.833 413.5,897.5C 410.5,897.5 407.5,897.5 404.5,897.5C 404.5,875.833 404.5,854.167 404.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28d0db",
    d: "M 448.5,832.5 C 457.839,832.334 467.173,832.5 476.5,833C 488.003,834.834 495.503,841.334 499,852.5C 502.988,867.509 499.821,880.675 489.5,892C 486.205,894.434 482.538,896.101 478.5,897C 468.506,897.5 458.506,897.666 448.5,897.5C 448.5,875.833 448.5,854.167 448.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#19ceda",
    d: "M 531.5,832.5 C 543.167,832.5 554.833,832.5 566.5,832.5C 566.5,835.167 566.5,837.833 566.5,840.5C 557.833,840.5 549.167,840.5 540.5,840.5C 540.5,847.167 540.5,853.833 540.5,860.5C 548.167,860.5 555.833,860.5 563.5,860.5C 563.5,863.5 563.5,866.5 563.5,869.5C 555.833,869.5 548.167,869.5 540.5,869.5C 540.5,876.167 540.5,882.833 540.5,889.5C 549.167,889.5 557.833,889.5 566.5,889.5C 566.5,892.167 566.5,894.833 566.5,897.5C 554.833,897.5 543.167,897.5 531.5,897.5C 531.5,875.833 531.5,854.167 531.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6f3f6",
    d: "M 597.5,832.5 C 597.5,854.167 597.5,875.833 597.5,897.5C 600.167,897.5 602.833,897.5 605.5,897.5C 602.713,898.477 599.713,898.81 596.5,898.5C 596.169,876.327 596.503,854.327 597.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1acfda",
    d: "M 597.5,832.5 C 601.106,832.211 604.606,832.544 608,833.5C 618.723,849.382 629.223,865.382 639.5,881.5C 639.783,882.289 640.283,882.956 641,883.5C 641.5,866.503 641.667,849.503 641.5,832.5C 644.5,832.5 647.5,832.5 650.5,832.5C 650.5,854.167 650.5,875.833 650.5,897.5C 646.774,897.823 643.107,897.489 639.5,896.5C 628.418,880.004 617.584,863.337 607,846.5C 606.832,863.672 606.332,880.672 605.5,897.5C 602.833,897.5 600.167,897.5 597.5,897.5C 597.5,875.833 597.5,854.167 597.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4ecf0",
    d: "M 641.5,832.5 C 641.667,849.503 641.5,866.503 641,883.5C 640.283,882.956 639.783,882.289 639.5,881.5C 640.167,865.167 640.833,848.833 641.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15ceda",
    d: "M 703.5,897.5 C 700.5,897.5 697.5,897.5 694.5,897.5C 694.5,878.5 694.5,859.5 694.5,840.5C 688.833,840.5 683.167,840.5 677.5,840.5C 677.5,837.833 677.5,835.167 677.5,832.5C 691.833,832.5 706.167,832.5 720.5,832.5C 720.5,835.167 720.5,837.833 720.5,840.5C 714.833,840.5 709.167,840.5 703.5,840.5C 703.5,859.5 703.5,878.5 703.5,897.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0dced9",
    d: "M 747.5,832.5 C 750.5,832.5 753.5,832.5 756.5,832.5C 756.5,854.167 756.5,875.833 756.5,897.5C 753.5,897.5 750.5,897.5 747.5,897.5C 747.5,875.833 747.5,854.167 747.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1dcfdb",
    d: "M 801.5,860.5 C 808.648,861.492 815.981,861.825 823.5,861.5C 823.5,863.833 823.5,866.167 823.5,868.5C 815.981,868.175 808.648,868.508 801.5,869.5C 801.5,878.833 801.5,888.167 801.5,897.5C 798.167,897.5 794.833,897.5 791.5,897.5C 791.5,875.833 791.5,854.167 791.5,832.5C 803.5,832.5 815.5,832.5 827.5,832.5C 827.5,835.167 827.5,837.833 827.5,840.5C 818.833,840.5 810.167,840.5 801.5,840.5C 801.5,847.167 801.5,853.833 801.5,860.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5f3f6",
    d: "M 856.5,832.5 C 856.5,854.167 856.5,875.833 856.5,897.5C 859.167,897.5 861.833,897.5 864.5,897.5C 861.713,898.477 858.713,898.81 855.5,898.5C 855.169,876.327 855.503,854.327 856.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#11ceda",
    d: "M 856.5,832.5 C 859.5,832.5 862.5,832.5 865.5,832.5C 865.831,854.34 865.497,876.006 864.5,897.5C 861.833,897.5 859.167,897.5 856.5,897.5C 856.5,875.833 856.5,854.167 856.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#21cfda",
    d: "M 932.5,861.5 C 932.5,863.833 932.5,866.167 932.5,868.5C 924.833,868.5 917.167,868.5 909.5,868.5C 909.175,875.687 909.509,882.687 910.5,889.5C 919.167,889.5 927.833,889.5 936.5,889.5C 936.5,892.167 936.5,894.833 936.5,897.5C 924.5,897.5 912.5,897.5 900.5,897.5C 900.5,875.833 900.5,854.167 900.5,832.5C 912.5,832.5 924.5,832.5 936.5,832.5C 936.5,835.167 936.5,837.833 936.5,840.5C 927.833,840.5 919.167,840.5 910.5,840.5C 910.5,847.167 910.5,853.833 910.5,860.5C 918.019,860.175 925.352,860.508 932.5,861.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22cfdb",
    d: "M 966.5,832.5 C 977.231,832.097 987.898,832.597 998.5,834C 1008.68,840.578 1011.18,849.411 1006,860.5C 1003.1,864.569 999.271,867.236 994.5,868.5C 1000.62,877.916 1006.62,887.416 1012.5,897C 1008.83,897.667 1005.17,897.667 1001.5,897C 996.04,887.915 990.707,878.749 985.5,869.5C 982.572,868.516 979.572,868.183 976.5,868.5C 976.5,878.167 976.5,887.833 976.5,897.5C 973.167,897.5 969.833,897.5 966.5,897.5C 966.5,875.833 966.5,854.167 966.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abeef2",
    d: "M 976.5,840.5 C 976.5,847.167 976.5,853.833 976.5,860.5C 980.5,860.5 984.5,860.5 988.5,860.5C 984.366,861.485 980.032,861.818 975.5,861.5C 975.175,854.313 975.509,847.313 976.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 976.5,840.5 C 981.511,840.334 986.511,840.501 991.5,841C 999.429,843.706 1001.6,848.872 998,856.5C 995.592,859.62 992.426,860.953 988.5,860.5C 984.5,860.5 980.5,860.5 976.5,860.5C 976.5,853.833 976.5,847.167 976.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 458.5,840.5 C 484.428,838.336 494.595,850.002 489,875.5C 487.564,881.87 483.731,886.037 477.5,888C 471.213,889.107 464.88,889.607 458.5,889.5C 458.5,873.167 458.5,856.833 458.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0f8f9",
    d: "M 677.5,840.5 C 683.167,840.5 688.833,840.5 694.5,840.5C 694.5,859.5 694.5,878.5 694.5,897.5C 697.5,897.5 700.5,897.5 703.5,897.5C 700.375,898.479 697.042,898.813 693.5,898.5C 693.5,879.5 693.5,860.5 693.5,841.5C 687.974,841.821 682.64,841.488 677.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ae0e8",
    d: "M 801.5,860.5 C 809.167,860.5 816.833,860.5 824.5,860.5C 824.5,863.5 824.5,866.5 824.5,869.5C 816.833,869.5 809.167,869.5 801.5,869.5C 808.648,868.508 815.981,868.175 823.5,868.5C 823.5,866.167 823.5,863.833 823.5,861.5C 815.981,861.825 808.648,861.492 801.5,860.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#83e5eb",
    d: "M 932.5,861.5 C 933.473,863.948 933.806,866.615 933.5,869.5C 925.833,869.5 918.167,869.5 910.5,869.5C 910.5,876.167 910.5,882.833 910.5,889.5C 910.5,882.833 910.5,876.167 910.5,869.5C 918.167,869.5 925.833,869.5 933.5,869.5C 933.806,866.615 933.473,863.948 932.5,861.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#caf4f6",
    d: "M 531.5,832.5 C 531.5,854.167 531.5,875.833 531.5,897.5C 543.167,897.5 554.833,897.5 566.5,897.5C 554.678,898.495 542.678,898.828 530.5,898.5C 530.169,876.327 530.503,854.327 531.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#26d0db",
    d: "M 983.5,915.5 C 984.552,915.351 985.552,915.517 986.5,916C 893.89,966.555 801.057,1016.72 708,1066.5C 611.26,1017.21 514.427,968.047 417.5,919C 514.457,961.221 611.29,1004.05 708,1047.5C 800.107,1003.86 891.94,959.861 983.5,915.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb67fbad4e684693a0878db5ac299ec8.svg";
export { ForwardRef as ReactComponent };